import { Injectable, Output, EventEmitter } from '@angular/core';
import { Pageable } from '../entities/pages/pageable';
import { Page } from '../entities/pages/page';

@Injectable({
    providedIn: 'root'
})
export class PaginationService {
    @Output() updatePagination: EventEmitter<Page<any>> = new EventEmitter();

    constructor() { }

    getNextPage(page: Page<any>): Pageable {
        if (!page.last) {
            page.pageable.pageNumber = page.pageable.pageNumber + 1;
            this.updatePagination.emit(page);
        }
        return page.pageable;
    }

    getPreviousPage(page: Page<any>): Pageable {
        if (!page.first) {
            page.pageable.pageNumber = page.pageable.pageNumber - 1;
            this.updatePagination.emit(page);
        }
        return page.pageable;
    }

    getPageInNewSize(page: Page<any>, pageSize: number): Pageable {
        page.pageable.pageSize = pageSize;
        page.pageable.pageNumber = Pageable.FIRST_PAGE_NUMBER;
        this.updatePagination.emit(page);
        return page.pageable;
    }

    getFirstPage(page: Page<any>): Pageable {   
        page.pageable.pageNumber = 0;
        this.updatePagination.emit(page);       
        return page.pageable;
    }

    getLastPage(page: Page<any>): Pageable {        
        page.pageable.pageNumber = page.totalPages -1;          
        this.updatePagination.emit(page);       
        return page.pageable;
    }
}
